<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="sede"
        :content="header"
      />
    </template>
    <template slot="main">
      <DetalleBankAccount ref="bank" :form="form"/>
    </template>  
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isRoleUserConsultaProvider"
            mode="primary"
            :text="$t('app.save')"
            icon="check"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>

import { i18n } from '@/i18n'

import DetailLayout from '@/components/layout/DetailLayout.vue'
import DetalleBankAccount from '@/components/DetalleBankAccount.vue'

import { getCuentaBancaria } from '@/services/configurations/getCuentaBancaria'
import { addCuentaBancaria } from '@/services/configurations/addCuentaBancaria'
import { updateCuentaBancaria } from '@/services/configurations/updateCuentaBancaria'


export default {
  /* eslint-disable camelcase */
  name: 'bank-account',
  components: {
    DetailLayout,
    DetalleBankAccount
  },
  data: function () {
    return {
      searchView: false,
      activeName: 'es',
      distribuidores: [],
      header: {
        title: i18n.t('agenda.account_header'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'masters/society/locations/bankaccounts'
      },
      loadedFirstTime: false,
      form: this.getDefaultForm(),
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    }, 
    isRoleUserConsultaProvider: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return parseInt(this.$route.params.id)
    },
    idSede: function () {
      return parseInt(this.$route.params.idSede)
    },
    idCuenta: function () {
      return parseInt(this.$route.params.idCuenta)
    },
    isCreate: function () {
      return this.$route.params.idCuenta === -1
    },
  },
  watch: { 
    'form.PaymentType': function (value, oldValue) {
      if (!this.isCreate && value !== oldValue && oldValue !== '') {
        this.form = this.getDefaultForm()
        this.form.PaymentType = value
      }
    }
  },
  created: async function () {
    const breadcrumbs = []

    breadcrumbs.push({ path: 'masters', name: i18n.t('masters.header') })
    breadcrumbs.push({ path: 'masters/society', name: i18n.t('agenda.sociedad') })
    breadcrumbs.push({ path: 'masters/society/locations', name: i18n.t('sedes.header') })
    breadcrumbs.push({ path: 'masters/society/locations/bankaccounts', name: i18n.t('agenda.cuentas_bancarias') })
    if (!this.isCreate) {
      await this.downloadData(this.id)
      breadcrumbs.push({ path: '', name: this.form.BankCode })
      this.$store.commit('app/setheaderBreadCrumb', this.form.BankCode)
    } else {
      this.$route.params.idCuenta = -1
      breadcrumbs.push({
        path: '',
        name: i18n.t('agenda.add_bank_account')
      })
    }
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    getDefaultForm: function () {
      return {
        IdSociedad: null,
        PaymentType: '',
        AccountType: '',
        IBANAccountNumber: '',
        BankCode: '',
        BranchCode: '',
        Address: '',
        PostCode: '',
        Town: '',
        Province: '',
        CountryCode: '',
        BIC: '',
        DomiciliationDate: ''
      }
    },
    watchFormHandler: function () {},
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function () {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs.bank.validate(valid => {
        if (valid) {
          const params = {
            IdSociedad: this.id,
            IdSede: this.idSede,
            PaymentType: this.form.PaymentType || '',
            AccountType: this.form.AccountType || 'IBAN',
            IBANAccountNumber: this.form.IBANAccountNumber || '',
            BankCode: this.form.IBANAccountNumber.slice(4, 8) || '',
            BranchCode: this.form.IBANAccountNumber.slice(8, 12) || '',
            Address: {
              Address: this.form.Address || '',
              PostCode: this.form.PostCode || '',
              Town: this.form.Town || '',
              Province: this.form.Province || '',
              CountryCode: this.form.CountryCode || ''
            },
            BIC: this.form.BIC || '',
            DomiciliationDate: this.form.DomiciliationDate || '',
          }
          params.Address = Object.values(params.Address).every(x => x === '') ? null : params.Address // Se ocultan validaciones y datos de contacto (TEMPORAL? - 06/06/2025) 
          
          if (this.isCreate) {
            this.newAccountHandler(params)
          } else {
            this.updateAccountHandler(params)
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
          this.$store.commit('setIsLoading', false)
        }
      })
    },
    resetForm: async function () {
      this.$refs.bank.getDefaultForm()
    },
    newAccountHandler: async function (params) {
      const response = await addCuentaBancaria(params)
      if (response.blnError === false) {
        this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
        this.goBack()
      } else {
        this.doFeedback(response.msgError)
      }
      this.$store.commit('setIsLoading', false)
    },
    updateAccountHandler: async function (params) {
      const data = {
        ...params,
        IdBankAccount: this.idCuenta
      }
      const response = await updateCuentaBancaria(data)
      if (response.blnError === false) {
        this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
        this.goBack()
      } else {
        this.doFeedback(response.msgError)
      }
      
      this.$store.commit('setIsLoading', false)
    },
    goBack: function () {
      this.$router.push({
        name: 'masters/society/locations/bankaccounts',
        params: { id: this.id, idSede: parseInt(this.$route.params.idSede) } 
      })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idSociedad: id,
          idSede: parseInt(this.$route.params.idSede),
          idCuenta: parseInt(this.$route.params.idCuenta)
        }
        const res = await getCuentaBancaria(params)
        this.setAccount(res.respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setAccount: function (res) {
      this.form.PaymentType = res.PaymentType
      this.form.AccountType = res.AccountType
      this.form.IBANAccountNumber = res.IBANAccountNumber
      this.form.BankCode = res.BankCode
      this.form.BranchCode = res.BranchCode
      this.form.Address = res.Address?.Address
      this.form.PostCode = res.Address?.PostCode
      this.form.Town = res.Address?.Town
      this.form.Province = res.Address?.Province
      this.form.CountryCode = res.Address?.CountryCode
      this.form.BIC = res.BIC
      this.form.DomiciliationDate = res.DomiciliationDate
    },
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
